<template>
  <div id="arquivos-edital">
    <div class="row">
      <div class="col-xs-12">
        <h3 class="custom-subtitle">Arquivos do Edital</h3>
      </div>
    </div>
    <div class="row">
      <input-vagas
        :cssClass="'col-xs-12'"
        :label="'Descrição do Arquivo'"
        :class="['custom-font', { 'is-danger': errors.has('descricao') }]"
        :name="'descricao'"
        :error="errors.has('descricao') ? errors.first('descricao') : ''"
        v-model="model.descricao"
        v-validate="'required'"
      />
      <div class="form-group col-xs-12 col-sm-6 col-md-3">
        <label
          :class="[
            'custom-font',
            { 'is-danger': errors.has('data_publicacao') }
          ]"
          >Data de Publicação</label
        >
        <datepicker
          v-model="model.data_publicacao"
          name="data_publicacao"
          ref="data_publicacao"
        ></datepicker>
      </div>
      <input-vagas
        :label="'Página da Publicação'"
        :class="['custom-font', { 'is-danger': errors.has('pagina') }]"
        :name="'pagina'"
        :error="errors.has('pagina') ? errors.first('pagina') : ''"
        v-model="model.pagina"
        v-validate="'required|numeric'"
      />
      <div class="col-xs-12 form-group">
        <button class="btn btn-default" :disabled="isLoading" @click="salvar()">
          <font-awesome-icon v-if="isLoading" :icon="'spinner'" spin />
          <font-awesome-icon v-else :icon="model.id ? 'save' : 'plus'" />
          {{ model.id ? 'Salvar' : 'Adicionar' }}
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <data-table
          ref="vuetable"
          :dados="arquivosEdital"
          :fields="fields"
          :carregando="isLoading"
        >
          <template slot="rowrender" slot-scope="props">
            <button
              class="btn btn-success"
              @click="selecionarArquivo(props.rowData)"
            >
              <font-awesome-icon :icon="'edit'" />
              <span class="sr-only">Editar</span>
            </button>
            <button
              title="Excluir Arquivo"
              class="btn btn-danger"
              @click="excluir(props.rowData)"
            >
              <font-awesome-icon :icon="'trash-alt'" />
            </button>
          </template>
        </data-table>
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom-subtitle {
  color: #00615c;
}

.custom-font {
  font-size: 16px;
  color: #00615c;
}

.custom-font.is-danger {
  color: #990000;
}
</style>

<script>
import InputVagas from './InputVagas.vue'
import DataTable from '@/components/common/NoApiTable'
import Datepicker from '@/components/common/Datepicker'
import { request } from '@/request'
import { formatToDatabaseDate, scrollToElement } from '@/utils'

export default {
  inject: ['showConfirm'],
  components: { InputVagas, DataTable, Datepicker },
  props: {
    edital: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      model: {
        data_publicacao: new Date(),
        pagina: 1
      },
      arquivosEdital: [],
      fields: [
        {
          name: 'descricao',
          title: 'Descrição'
        },
        {
          name: 'data_publicacao',
          title: 'Data de Publicação',
          callback(value) {
            return new Date(`${value} 00:00`).toLocaleDateString()
          }
        },
        {
          name: 'pagina',
          title: 'Página de Publicação',
          callback(value) {
            return `Página ${value}`
          }
        },
        {
          name: '__slot:actions',
          title: 'Ações',
          titleClass: 'text-center',
          dataClass: 'text-center col-xs-3'
        }
      ],
      isLoading: false
    }
  },
  created() {
    this.model.edital_id = this.edital.id
    this.carregarArquivos()
  },
  methods: {
    toggleLoading() {
      this.isLoading = !this.isLoading
    },
    selecionarArquivo(item) {
      const { data_publicacao } = item
      this.model = {
        ...item,
        data_publicacao: new Date(`${data_publicacao} 00:00`)
      }
      scrollToElement('arquivos-edital')
    },
    salvar() {
      this.toggleLoading()
      this.$validator.validateAll().then(result => {
        if (!result) {
          this.toggleLoading()
          this.$toastr.e(this.$validator.errors.items[0].msg)
          return
        }

        const { id } = this.model

        if (id) {
          request
            .put(`arquivosEdital/${id}`, this.formatedModel)
            .then(response => {
              const { data } = response
              this.$toastr.s(`${data.descricao} atualizado com sucesso.`)
              this.limparCampos()
            })
            .catch(error => {
              this.$toastr.e(
                'Houve um erro ao salvar o edital, verifique as informações e tente novamente.'
              )
              console.log(error.response)
            })
            .finally(() => {
              this.toggleLoading()
              this.carregarArquivos()
            })
        } else {
          request
            .post('arquivosEdital', this.formatedModel)
            .then(response => {
              const { data } = response
              this.$toastr.s(`${data.descricao} inserido com sucesso.`)
              this.model.descricao = ''
              this.model.pagina = '1'
            })
            .catch(error => {
              this.$toastr.e(
                'Houve um erro ao salvar o edital, verifique as informações e tente novamente.'
              )
              console.log(error.response)
            })
            .finally(() => {
              this.toggleLoading()
              this.carregarArquivos()
            })
        }
      })
    },
    limparCampos() {
      this.model = {
        ...this.model,
        descricao: '',
        pagina: '1',
        id: ''
      }
    },
    carregarArquivos() {
      this.toggleLoading()
      const { numero } = this.edital
      request
        .get('arquivosEdital', { params: { nr_edital: numero } })
        .then(response => {
          const { data } = response
          this.arquivosEdital = data
        })
        .catch(error => {
          this.$toastr.e(
            'Houve um erro ao carregar os arquivos. Atualize a página e tente novamente.'
          )
          console.log(error.response)
        })
        .finally(this.toggleLoading)
    },
    excluir(item) {
      const { id, descricao } = item

      var config = {
        title: 'Alerta',
        question: true,
        yes: () => {
          this.toggleLoading()
          request
            .delete(`arquivosEdital/${id}`)
            .then(response => {
              this.$toastr.s('Arquivo excluído com sucesso!')
              console.log(response.data)
              this.carregarArquivos()
            })
            .catch(error => {
              this.$toastr.e(
                'Houve um problema ao excluir o item. Tente novamente'
              )
              console.log(error.response)
            })
            .finally(this.toggleLoading)
        }
      }

      this.showConfirm(`Deseja excluir o arquivo "${descricao}"`, config)
    }
  },
  computed: {
    formatedModel() {
      const { data_publicacao, pagina } = this.model

      return {
        ...this.model,
        data_publicacao: formatToDatabaseDate(data_publicacao),
        pagina: parseInt(pagina)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/concursos/edital/ArquivosEdital.vue